'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* the icarus renderer is responsible for rendering each of the form fields, validation messages, and errors */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */


var _device = require('./lib/device');

var _utils = require('./lib/utils');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debounce = require('lodash/debounce');

// we load these templates directly instead of in webpack.config because doing it this way avoids clients from having
// to include .ejs loader patterns in their webpack.config
var formTemplate = require('ejs-loader!./templates/form.ejs');
var fieldTemplate = require('ejs-loader!./templates/field.ejs');
var inputControl = require('ejs-loader!./templates/controls/input.ejs');
var selectControl = require('ejs-loader!./templates/controls/select.ejs');
var richtextControl = require('ejs-loader!./templates/controls/richtext.ejs');
var textareaControl = require('ejs-loader!./templates/controls/textarea.ejs');
var radioControl = require('ejs-loader!./templates/controls/radio.ejs');

/**
 * the renderer of an icarus form is responsible for:
 *
 * - rendering the form into the DOM
 * - displaying any validation errors
 * - registering DOM event listeners with the controller
 *
 * @param selector @{String} - the selector of the container for the form
 * @param formName @{String} - the title of the form (as rendered)
 * @param formFields @{Array} - Field objects containing validation and render information
 * @param formSubmitButton @{String} - the label to use for the submit button
 * @param controller @{Object} - an IcarusController instance
 */

var IcarusRenderer = function () {
    function IcarusRenderer(selector, _ref) {
        var formName = _ref.formName,
            formFields = _ref.formFields,
            formSubmitButton = _ref.formSubmitButton,
            controller = _ref.controller;

        _classCallCheck(this, IcarusRenderer);

        this._selector = selector;
        this._formName = formName;
        this._formFields = formFields;
        this._formSubmitButton = formSubmitButton;
        this._controller = controller;

        // a mapping of field ID -> layout object for that field
        this._layouts = null;
        // true if the form is currently in the process of submitting, false otherwise
        this._isSubmitting = false;
        // if set, this message will be rendered as a form-level message
        this._formMessage = null;
        // if true, then field updates are locked (e.g. fields will not trigger controller updates)
        this._fieldUpdateLock = false;

        this.initialize();
    }

    _createClass(IcarusRenderer, [{
        key: 'initialize',
        value: function initialize() {
            this.registerControllerListeners();

            this.registerWindowListeners();
        }

        //-- Window And Controller Listener Registration --//

    }, {
        key: 'registerControllerListeners',
        value: function registerControllerListeners() {
            var _this = this;

            this.controller.addListener('icarus:field:validation_success,icarus:field:validation_fixed', function (field, _ref2) {
                var validationStatus = _ref2.validationStatus,
                    rest = _objectWithoutProperties(_ref2, ['validationStatus']);

                return _this.renderField(field, { validationStatus: validationStatus, updateDOM: true });
            });

            this.controller.addListener('icarus:field:validation_error', function (field, _ref3) {
                var validationStatus = _ref3.validationStatus,
                    validationError = _ref3.validationError,
                    rest = _objectWithoutProperties(_ref3, ['validationStatus', 'validationError']);

                return _this.renderField(field, { validationStatus: validationStatus, validationError: validationError, updateDOM: true });
            });

            /** TODO: revisit this. The issue is, when dealing with touch screen devices, the appearance of the soft
             * keyboard triggers a window resize event. This results in the form re-rendering whenever the keyboard appears,
             * which prevents input from working.
             */
            // this.controller.addListener(
            //     'icarus:window:resize',
            //     () => {
            //         this.layouts = null;
            //         this.render();
            //     }
            // );

            this.controller.addListener('icarus:form:validated', function () {
                _this.isSubmitting = true;
                _this.render();
            });

            this.controller.addListener('icarus:form:error', function (status) {
                _this.isSubmitting = false;
                _this.formMessage = status;
                _this.render();
            });

            this.controller.addListener('icarus:form:saved', function (_ref4) {
                var redirectUrl = _ref4.redirectUrl,
                    successMessage = _ref4.successMessage;

                _this.isSubmitting = false;
                _this.formMessage = successMessage;
                _this.render();
            });
        }
    }, {
        key: 'registerWindowListeners',
        value: function registerWindowListeners() {
            var _this2 = this;

            window.addEventListener('resize', debounce(function () {
                return _this2.controller.trigger('icarus:window:resize');
            }, 200));
        }

        //-- Layout --//
        /**
         * gets the layout dimensions for the fields of the form
         */

    }, {
        key: 'getFieldLayouts',
        value: function getFieldLayouts() {
            var _this3 = this;

            var deviceCategory = (0, _device.getDeviceCategory)();
            var layouts = {};

            this.formFields.forEach(function (field) {
                if (!field.layout) return;

                var _field$layout = field.layout,
                    desktop_top_left = _field$layout.desktop_top_left,
                    desktop_width = _field$layout.desktop_width,
                    desktop_height = _field$layout.desktop_height,
                    mobile_top_left = _field$layout.mobile_top_left,
                    mobile_width = _field$layout.mobile_width,
                    mobile_height = _field$layout.mobile_height;


                var dims = deviceCategory === 'DESKTOP' ? { topLeft: desktop_top_left, width: desktop_width, height: desktop_height } : { topLeft: mobile_top_left, width: mobile_width, height: mobile_height };

                layouts[field.id] = IcarusRenderer.getFieldLayout({
                    dims: dims,
                    containerWidth: _this3.getContainerWidth(),
                    containerHeight: _this3.getContainerHeight()
                });
            });

            return layouts;
        }

        /**
         * get the `style` parameters for the layout of the given field in the form. Meaning,
         * we want to get the `top`, `left`, `width`, and `height` styles as an object.
         * @param dims @{Object} containing relative positioning / sizing information with keys: topLeft, width, height
         * @param containerWidth @{float} the width of the containing layout we're laying the `field` in
         * @param containerHeight @{float} the height of the containing layout we're laying the `field` in
         */

    }, {
        key: 'verifyLayout',


        /**
         * check that the layout doesn't have any overlapping fields or fields who's contents are cut off
         * because of sizing restrictions due to the combination of the containiners size and the specified layout.
         * @return @{Boolean} true if the layout passes the verification check. false o/w.
         */
        value: function verifyLayout() {
            var _this4 = this;

            var fields = this.getDOMFields();
            var fieldsArray = Array.from(fields);
            var numOverflows = fieldsArray.reduce(function (acc, domElement) {
                return _this4.hasOverflow(domElement) + 0 + acc;
            }, 0);

            if (numOverflows > 0) console.error(numOverflows + ' fields had layout overflow.');

            return numOverflows === 0 && !this.hasOverlaps();
        }

        /**
         * check if the given `icarus-field` element has overflow. Overflow is defined as the contents of the container
         * (label + input) escaping the height defined by the container.
         * @param domElement @{DOMElement} the element to check for overflow and - if there is any -
         * return the amount in pixels.
         * @return @{Boolean} true if the given dom element has overflow, false otherwise
         */

    }, {
        key: 'hasOverflow',
        value: function hasOverflow(domElement) {
            var layoutHeight = this.getLayoutForDOMElement(domElement).height;
            var elHeightStore = domElement.style.height;

            domElement.style.height = 'auto';

            var contentHeight = (0, _utils.getElementHeight)(domElement);

            domElement.style.height = elHeightStore;

            return contentHeight - layoutHeight > 0;
        }

        /**
         * check if any layouts overlap with any other layouts in the form.
         * @return @{Boolean} true if there are any overlapping elements. False otherwise.
         */

    }, {
        key: 'hasOverlaps',
        value: function hasOverlaps() {
            for (var i = 0; i < this.layouts.length - 1; i += 1) {
                if (this.getOverlaps(this.layouts[i], this.layouts.slice(i + 1)).length > 0) return true;
            }

            return false;
        }
    }, {
        key: 'getContainerWidth',


        //-- DOM Accessors --//
        value: function getContainerWidth() {
            return (0, _utils.getElementWidth)(this.getDOMElement());
        }
    }, {
        key: 'getContainerHeight',
        value: function getContainerHeight() {
            return (0, _utils.getElementHeight)(this.getDOMElement());
        }
    }, {
        key: 'getDOMElement',
        value: function getDOMElement() {
            return document.querySelectorAll(this.selector)[0];
        }
    }, {
        key: 'getDOMFields',
        value: function getDOMFields() {
            return Array.from(this.getDOMElement().querySelectorAll('.icarus-field'));
        }

        /**
         * get the layout from this.layouts for the given DOM element representing a rendered field in the DOM
         * @param icFieldEl @{DOMElement} to get the layout for
         */

    }, {
        key: 'getLayoutForDOMElement',
        value: function getLayoutForDOMElement(icFieldEl) {
            var fieldId = IcarusRenderer.getFieldId(icFieldEl);
            return this.layouts[fieldId] !== undefined && this.layouts[fieldId];
        }
    }, {
        key: 'getDOMFieldForId',
        value: function getDOMFieldForId(fieldId) {
            return this.getDOMFields().filter(function (domElement) {
                return IcarusRenderer.getFieldId(domElement) === fieldId;
            })[0];
        }
    }, {
        key: 'getDOMFieldControlForId',
        value: function getDOMFieldControlForId(fieldId) {
            var controls = this.getDOMFieldForId(fieldId).querySelectorAll('input,select,textarea');

            if (controls.length === 0) {
                throw new Error('field ' + fieldId + ' has no control');
            } else if (controls.length > 1) {
                // only the radio input should have multiple controls within a field grouping. Sort to prefer the
                // checked one
                controls = controls.sort(function (a, b) {
                    return a.checked ? -1 : 1;
                });
            }

            return controls[0];
        }

        /**
         * sort the given list of fields by their layout distance from the top of the form, secondary sort is
         * by the distance from the left side of the form. Important to note is that this function will not include
         * fields with no layout in its output.
         * @param fields @{Array} of @{Object} list of fields to sort by layout
         * @return @{Array} of @{Object} the fields sorted by their layout
         */

    }, {
        key: 'sortedFieldsByLayout',
        value: function sortedFieldsByLayout(fields) {
            var _this5 = this;

            return fields.filter(function (f) {
                return !!_this5.layouts[f.id];
            }).sort(function (a, b) {
                var aLayout = _this5.layouts[a.id];
                var bLayout = _this5.layouts[b.id];

                if (aLayout.top < bLayout.top) {
                    return -1;
                } else if (aLayout.top === bLayout.top) {
                    return aLayout.left < bLayout.left ? -1 : 1;
                }

                return 1;
            });
        }

        /**
         * sort the given list of fields by their index (ascending order)
         * @param fields
         */

    }, {
        key: 'registerFormListeners',


        //-- Render (+ DOM Event Listening) --//
        value: function registerFormListeners(domElement) {
            var _this6 = this;

            domElement.onsubmit = function (evt) {
                evt.preventDefault();

                _this6.formFields.forEach(function (icField) {
                    icField.value = _this6.getBestFieldValue(icField);
                });

                _this6.controller.trigger('icarus:form:submitted', _this6.formFields);
            };
        }
    }, {
        key: 'registerFieldListeners',
        value: function registerFieldListeners(icField) {
            var _this7 = this;

            var domElement = this.getDOMFieldForId(icField.id);

            var triggerChange = function triggerChange(evt) {
                // the fieldUpdateLock is to prevent duplicate renders for the case where an event CAUSES another event.
                // For example, if we have a select field, the change of that field triggers this handler, which then
                // updates the controller, causing a re-render (and rebinding of field listeners). This re-render then
                // triggers a blur event, which causes a duplicate re-render here.
                if (!_this7._fieldUpdateLock) {
                    _this7._fieldUpdateLock = true;
                    setTimeout(function () {
                        _this7._fieldUpdateLock = false;
                    }, 100);

                    icField.value = icField.input_type !== 'CHECKBOX' ? evt.target.value : evt.target.checked;
                    _this7.controller.trigger('icarus:field:changed', icField, icField.value);
                }
            };

            domElement.onchange = triggerChange;
            domElement.addEventListener('focusout', triggerChange);
        }

        /**
         * check if there are any fields that have a different value set in the DOM than on the field object.
         * This might occur if - for instance - a val was set programatically, as this would not trigger the DOM
         * event listener to update the field object. When a difference is found, choose the DOM value as the
         * source of truth
         * @param icField - @{Object} field to reconcile
         * @return @{String} best value to use for the field
         */

    }, {
        key: 'getBestFieldValue',
        value: function getBestFieldValue(icField) {
            var bestValue = icField.value;
            var domValue = null;

            // we need to wrap this for the case that the form field has no control (for instance, in the case
            // of a richtext snippet)
            try {
                domValue = this.getDOMFieldControlForId(icField.id).value;
            } catch (exc) {
                console.warn('got exception ' + exc.toString() + ' getting DOM value for ' + icField.name);
                domValue = null;
            }

            if (domValue) {
                console.info(icField.name + ' has field value ' + bestValue + ' and DOM value ' + domValue + ', choose DOM');
                bestValue = domValue;
            }

            return IcarusRenderer.cleanFieldValue(bestValue);
        }

        /**
         * clean the given field value so nothing breaks when the value is injected into the DOM. For instance, one cleaning
         * operation is escaping quotes.
         * @param value
         */

    }, {
        key: 'renderField',


        /**
         * render an Icarus field. The behavior of rendering is one of either:
         *
         * 1) to render into a string and replace the existing field in the DOM with the rendered string
         * 2) or to simply return the rendered string without replacement.
         *
         * The branching of behavior is dependent on the value of the updateDOM variable.
         * @param field
         * @param updateDOM @{Boolean} should we update the DOM with the rendered field
         * @param validationStatus @{String} the status of the validation of the field. One of 'validated', 'error',
         * @param validationError @{String} description of validation error
         * or null (neither valid nor invalid e.g. hasn't been interacted with)
         * @throws exception if an attempt to update the DOM occurs for a field which has no DOM element
         * @return @{String} rendered field
         */
        value: function renderField(field, _ref5) {
            var updateDOM = _ref5.updateDOM,
                validationStatus = _ref5.validationStatus,
                validationError = _ref5.validationError;

            var renderedField = fieldTemplate({
                field: field,
                validationStatus: validationStatus,
                error: validationError,
                control: IcarusRenderer.getControlTemplateForField(field),
                fieldLayout: this.layouts[field.id],
                getFieldValue: function getFieldValue() {
                    return field.value !== undefined ? field.value : field.default_value;
                }
            });

            if (updateDOM) {
                var domElement = this.getDOMFieldForId(field.id);

                if (!domElement) throw new Error('no DOM element for field ' + field.id);

                domElement.outerHTML = renderedField;

                this.registerFieldListeners(field);
            }

            return renderedField;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this8 = this;

            var el = this.getDOMElement();
            var renderForm = function renderForm(dynamicFields, staticFields) {
                var boundingBox = IcarusRenderer.getBoundingBox({
                    layouts: dynamicFields.map(function (f) {
                        return _this8.layouts[f.id];
                    })
                });

                el.innerHTML = formTemplate({
                    form: {
                        name: _this8.formName,
                        submitButton: _this8.formSubmitButton,
                        isSubmitting: _this8.isSubmitting,
                        message: _this8.formMessage,
                        staticFields: IcarusRenderer.sortedFieldsByIndex(staticFields).map(_this8.renderField.bind(_this8)),
                        dynamicFields: _this8.sortedFieldsByLayout(dynamicFields).map(_this8.renderField.bind(_this8)),
                        dynamicBoundingBox: boundingBox
                    }
                });
            };

            renderForm(this.formFields.filter(function (f) {
                return _this8.layouts[f.id];
            }), this.formFields.filter(function (f) {
                return !_this8.layouts[f.id];
            }));

            // verify the rendered layout. If there are any problems, then we need to just revert to a safe layout with
            // no dynamically placed fields
            if (!this.verifyLayout()) renderForm([], this.formFields);

            this.registerFormListeners(el);
            this.formFields.map(this.registerFieldListeners.bind(this));

            this.controller.trigger('icarus:form:rendered', el);
        }
    }, {
        key: 'selector',
        get: function get() {
            return this._selector;
        }
    }, {
        key: 'formName',
        get: function get() {
            return this._formName;
        }
    }, {
        key: 'formFields',
        get: function get() {
            return this._formFields;
        },
        set: function set(formFields) {
            this._formFields = formFields;
        }
    }, {
        key: 'formSubmitButton',
        get: function get() {
            return this._formSubmitButton;
        }
    }, {
        key: 'controller',
        get: function get() {
            return this._controller;
        }
    }, {
        key: 'layouts',
        get: function get() {
            if (!this._layouts) this._layouts = this.getFieldLayouts();

            return this._layouts;
        },
        set: function set(layouts) {
            this._layouts = layouts;
        }
    }, {
        key: 'isSubmitting',
        get: function get() {
            return this._isSubmitting;
        },
        set: function set(isSubmitting) {
            this._isSubmitting = isSubmitting;
        }
    }, {
        key: 'formMessage',
        get: function get() {
            return this._formMessage;
        },
        set: function set(message) {
            this._formMessage = message;
        }
    }], [{
        key: 'getFieldLayout',
        value: function getFieldLayout(_ref6) {
            var dims = _ref6.dims,
                containerWidth = _ref6.containerWidth,
                containerHeight = _ref6.containerHeight;

            return {
                top: dims.topLeft[1] * containerHeight,
                left: dims.topLeft[0] * containerWidth,
                width: dims.width * containerWidth,
                height: dims.height * containerHeight
            };
        }

        /**
         * get the bounding box for the given list of layout objects
         * @param layouts @{Object} list of layout objects having keys: top, left, width, height
         * @return @{Object} with keys: topLeft, bottomRight
         */

    }, {
        key: 'getBoundingBox',
        value: function getBoundingBox(_ref7) {
            var layouts = _ref7.layouts;

            var minX = Infinity;
            var minY = Infinity;
            var maxX = -Infinity;
            var maxY = -Infinity;

            layouts.forEach(function (layout) {
                if (layout.left < minX) minX = layout.left;
                if (layout.top < minY) minY = layout.top;
                if (layout.left + layout.width > maxX) maxX = layout.left + layout.width;
                if (layout.top + layout.height > maxY) maxY = layout.top + layout.height;
            });

            return { topLeft: [minX, minY], bottomRight: [maxX, maxY] };
        }
    }, {
        key: 'getOverlaps',
        value: function getOverlaps(layout, otherLayouts) {
            return otherLayouts.filter(function (l) {
                return IcarusRenderer.doesOverlap(layout, l);
            });
        }

        /**
         * check if one layout overlaps another
         * @param layout1 @{Object} having properties: top, left, width, height given in pixel values
         * @param layout2 @{Object} having properties: top, left, width, height given in pixel values
         */

    }, {
        key: 'doesOverlap',
        value: function doesOverlap(layout1, layout2) {
            return layout1.top < layout2.top && layout2.top < layout1.top + layout1.height && layout1.left < layout2.left && layout2.left < layout1.left + layout1.width;
        }

        /**
         * get the ID of the field rendered as the DOM element `icFieldEl`
         * @param icFieldEl @{DOMElement}
         * @returns {Number}
         */

    }, {
        key: 'getFieldId',
        value: function getFieldId(icFieldEl) {
            return parseInt(icFieldEl.getAttribute('data-field-id'), 10);
        }
    }, {
        key: 'sortedFieldsByIndex',
        value: function sortedFieldsByIndex(fields) {
            return fields.sort(function (a, b) {
                return a.index <= b.index ? -1 : 1;
            });
        }
    }, {
        key: 'cleanFieldValue',
        value: function cleanFieldValue(value) {
            var escapePattern = /["]+/g;

            return value !== undefined && value !== null ? value.replace(escapePattern, '') : value;
        }

        //-- Render Methods --//
        /**
         * get the control template to use for the given field
         * @param field
         */

    }, {
        key: 'getControlTemplateForField',
        value: function getControlTemplateForField(field) {
            if (['TEXT', 'HIDDEN', 'CHECKBOX'].indexOf(field.input_type) >= 0) {
                return inputControl;
            } else if (field.input_type === 'TEXTAREA') {
                return textareaControl;
            } else if (field.input_type === 'RICHTEXT') {
                return richtextControl;
            } else if (field.input_type === 'RADIO') {
                return radioControl;
            }

            return selectControl;
        }
    }]);

    return IcarusRenderer;
}();

exports.default = IcarusRenderer;


//////////////////
// WEBPACK FOOTER
// ./~/icarus-forms/module/js/renderer.js
// module id = 196
// module chunks = 2 3